



















import { Component, Prop, Ref, Vue, Watch } from 'vue-property-decorator'

export interface ListItemClickEvent<T> {
    item: T
}

@Component
export default class ListItem<T> extends Vue {

    @Prop({ type: String })
    readonly containerId!: string

    @Prop({ type: [Object, String] })
    readonly item!: T

    @Prop({ type: String })
    readonly itemKey!: string

    @Prop({ type: String, default: null })
    readonly draggableContainerId!: string

    @Prop({ type: Boolean, default: false })
    readonly dragContainerTargeted!: string

    @Prop({ type: Boolean, default: false })
    readonly clickable!: boolean

    @Prop({ type: Boolean, default: false })
    readonly noActionAfterCollapse!: boolean

    @Prop({ type: Boolean, default: false })
    readonly collapsed!: boolean

    @Prop({ type: Boolean, default: false })
    readonly active!: boolean

    @Ref('list-item')
    readonly listItem!: HTMLElement

    dragActive = false
    dragOver = false
    dragOverTimeout = null

    onClick(target: Element) {
        if (target.matches('.list-item-action')) {
            return
        }

        if (!target.matches('.list-item')
            && !target.matches('.list-item__container')
        ) {
            return
        }

        this.$emit('list-item-click', { item: this.item })
    }

    get classes(): object {
        return {
            'list-item': true,
            'list-item--clickable': this.clickable,
            'list-item--dragover': this.dragOver,
            'list-item--active': this.active,
            'list-item--collapsed': this.collapsed,
            'list-item--no-action-when-collapsed': this.noActionAfterCollapse,
            'list-item--current-dropzone': this.dragOver && this.dragActive,
            'list-item--drag-container-targeted': this.dragContainerTargeted,
            [this.containerId]: true,
        }
    }

    dragStartHandler(event: DragEvent) {
        this.$root.$dragItem = event.target as HTMLElement
        event.dataTransfer.setDragImage(this.listItem, 0, 0)
        event.dataTransfer.setData('draggableContainerId', this.draggableContainerId)
        event.dataTransfer.setData('containerId', this.containerId)
        event.dataTransfer.setData('itemKey', this.itemKey)
    }

    dragEndHandler(event: DragEvent) {
        this.dragActive = false
    }

    dragOverHandler(event: DragEvent) {
        event.preventDefault()
        event.dataTransfer.dropEffect = 'move'

        if (this.dragOverTimeout !== null) {
            clearTimeout(this.dragOverTimeout)
            this.dragOverTimeout = null
        }

        this.dragOver = true
        this.dragOverTimeout = setTimeout(() => {
            this.dragOver = false
            this.dragOverTimeout = null
        }, 150)
    }
}
